"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceType = void 0;
var PlaceType;
(function (PlaceType) {
    PlaceType["SITE"] = "site";
    PlaceType["SUPPLIER"] = "supplier";
    PlaceType["OFFICE"] = "office";
    PlaceType["PROJECT"] = "project";
    PlaceType["SERVICE_ORDER"] = "service-order";
})(PlaceType = exports.PlaceType || (exports.PlaceType = {}));
